import { Tabs } from 'antd';
import { FC, useState } from 'react';

import KakaoAlimtalkSend from './KakaoAlimtalkSend';
import { dayOffConfig } from './templates/day-off';
import { AlimtalkTemplateConfig } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const templateConfigs: AlimtalkTemplateConfig<any>[] = [dayOffConfig];

const KakaoAlimtalkPage: FC = () => {
  const [activeKey, setActiveKey] = useState<string>(templateConfigs[0].templateCode);

  const activeConfig = templateConfigs.find((c) => c.templateCode === activeKey) ?? templateConfigs[0];

  return (
    <>
      <Tabs
        activeKey={activeKey}
        onChange={setActiveKey}
        size='small'
        style={{ marginBottom: 0 }}
        items={templateConfigs.map((config) => ({
          key: config.templateCode,
          label: config.label,
        }))}
      />
      <KakaoAlimtalkSend key={activeKey} config={activeConfig} />
    </>
  );
};

export default KakaoAlimtalkPage;
